//>>> Routing utilities for role-based navigation
import { useAuthStore } from '@stores/auth.store';

/**
 * Determines if a user role is an owner/admin role
 * Owner roles typically include: super-admin, admin, owner, sub-admin
 * @param {string} role - User's role
 * @returns {boolean}
 */
export const isOwnerRole = (role) => {
    if (!role) return false;

    const ownerRoles = ['super-admin', 'admin', 'owner', 'sub-admin', 'superadmin'];
    return ownerRoles.some((ownerRole) => role.toLowerCase().includes(ownerRole.toLowerCase()));
};

/**
 * Determines if a user role is a tenant role
 * @param {string} role - User's role
 * @returns {boolean}
 */
export const isTenantRole = (role) => {
    if (!role) return false;
    return !isOwnerRole(role);
};

/**
 * Gets the appropriate dashboard route based on user role
 * @param {string} role - User's role
 * @returns {string} Dashboard route path (clean URL without owner/tenant)
 */
export const getDashboardRoute = (role) => {
    // Always return /dashboard - the component will be determined by role
    return '/dashboard';
};

/**
 * Gets the dashboard route for the current authenticated user
 * @returns {string} Dashboard route path
 */
export const getCurrentUserDashboardRoute = () => {
    const role = useAuthStore.getState().role;
    return getDashboardRoute(role);
};
